import { topicsData } from "@/mocks/homeData";

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2 font-heading">🏷️ 热门话题</h2>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10">当前最受关注的吃瓜话题标签，点击探索更多</p>

        <div className="flex flex-wrap gap-3">
          {topicsData.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => { e.preventDefault(); const el = document.querySelector("#cards"); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" }); }}
              className="group flex items-center gap-3 bg-background-100 border border-background-200/70 hover:border-primary-200/50 rounded-xl px-4 py-3 cursor-pointer transition-all"
            >
              <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${topic.color}`}></span>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.name}</span>
                  {topic.hot && (
                    <span className="text-[10px] px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded font-semibold whitespace-nowrap">HOT</span>
                  )}
                </div>
                <span className="text-xs text-foreground-500">{topic.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}